import React, { useState } from 'react';
import ModalInferior from '../components/ModalInferior';
import '../css/components/PoliticaPrivacidadCheckbox.css';
import iconInfo from '../assets/img/icon_info.svg';
import iconClose from '../assets/img/icon_close.svg';

export default function PoliticaPrivacidadCheckbox(props) {
  const { updateCheckedValue, urlModal, onClickModal, onClickTagueoCheck, css } = props;

  const [state, setState] = useState({
    id: props.id,
    isChecked: props.isChecked ? props.isChecked : false,
    modalOpen: false,
  });

  function abrirDocumentoTDP() {
    if (onClickModal) {
      onClickModal();
    }
    setState({
      ...state,
      modalOpen: true,
    });
  }

  function onClose() {
    setState({
      ...state,
      modalOpen: false,
    });
  }

  function handleChange(event) {
    updateCheckedValue(!state.isChecked);
    onClickTagueoCheck(event);
    setState({ ...state, isChecked: !state.isChecked });
    return;
  }

  return (
    <div className={css ? css : "checkbox_wrapper"}>
      <input
        id={state.id}
        className="checkbox"
        type="checkbox"
        checked={state.isChecked}
        onChange={handleChange}
      ></input>
      <label
        htmlFor={state.id}
        className="input-control__label checkbox-lpdp__agrupado"
      >
        <span className="input-control__box checkbox-lpdp__responsive">
          <svg
            className="checkbox__check"
            width="18"
            height="14"
            viewBox="0 0 18 14"
            fillRule="evenodd"
          >
            <path d="M16.667 0L6 10.61 1.333 5.97 0 7.295l6 5.968 1.405-1.398L18 1.325" />
          </svg>
        </span>
      </label>
      <div className="checkbox-lpdp__texto-confirmacion">
        <div>
          {`Autorizo el tratamiento de mis datos personales para `}
          <a
            className="checkbox-lpdp__texto-direccion"
            onClick={abrirDocumentoTDP}
          >
            fines comerciales y/o publicitarios
          </a>
          .
        </div>
      </div>

      {state.modalOpen && (
          <ModalInferior>
            <section className='flex flex-col gap-4 p-4'>
              <div className='flex justify-between'>
                <aside>
                <img className="w-24" src={iconInfo}/>
                </aside>
                <aside>
                  <img className="w-10 cursor-pointer" src={iconClose} onClick={onClose} />
                </aside>
              </div>
              <label className='font-bbvaTiempos text-4xl'>Fines comerciales y/o publicitarios</label>
            <iframe title='Politica de Privacidad'
              className="bloque-lpdp__modal-style"
              src={urlModal}
            ></iframe>
            </section>     
          </ModalInferior>
      )}
    </div>
  );
}
